/* ============================================================
   Long Run Co. — Refer a Runner renderer
   Data: loyalty proxy customer-loyalty object →
     • referralLink  (Appstle's REAL tracked URL, never faked /
       never displayed — used only inside share handlers)
     • referredCompleted  (count of completed referrals)
   Optional enrichment: customer-referrals (pending/completed).
   The customer-loyalty fetch is MEMOISED on window so this section
   and Rewards share ONE call (no duplicate cp requests).
   ============================================================ */
(function () {
  "use strict";
  var roots = document.querySelectorAll("[data-lrc-mp-refer]");
  if (!roots.length) return;

  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
    return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function num(v) { var n = parseFloat(v); return isNaN(n) ? null : n; }
  function pick(o, paths, d) {
    for (var i = 0; i < paths.length; i++) { var c = o, ok = true, p = paths[i].split(".");
      for (var j = 0; j < p.length; j++) { if (c != null && typeof c === "object" && p[j] in c) c = c[p[j]]; else { ok = false; break; } }
      if (ok && c != null && c !== "") return c; } return d;
  }
  function toArray(x) { if (Array.isArray(x)) return x; if (x == null) return []; if (typeof x === "object") { var k = ["content","data","items","results","list","referrals"]; for (var i = 0; i < k.length; i++) if (Array.isArray(x[k[i]])) return x[k[i]]; return [x]; } return []; }

  /* MEMOISED customer-loyalty: shared with the Rewards section via window cache,
     keyed by base → only one network call regardless of how many sections ask. */
  function clFetch(base) {
    var W = window; W.__LRCMP_CL__ = W.__LRCMP_CL__ || {};
    if (W.__LRCMP_CL__[base]) return W.__LRCMP_CL__[base];
    var p = fetch(base + "customer-loyalty", { method: "GET", credentials: "same-origin", headers: { "Accept": "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    W.__LRCMP_CL__[base] = p;
    return p;
  }

  /* a referral URL is only trusted if it is a real http(s) link (never construct one) */
  function referralUrlOf(cust) {
    var u = pick(cust, ["referralLink", "referralUrl", "referral_link", "customerReferralLink", "shareUrl", "referralShareUrl"], null);
    return (typeof u === "string" && /^https?:\/\//i.test(u)) ? u : null;
  }
  function completedOf(cust) {
    return num(pick(cust, ["referredCompleted", "referralCompleted", "completedReferrals", "referredCount", "successfulReferrals"], null));
  }

  /* design-mode sample (so the module is stylable without a session) */
  function sampleCustomer() { return { referralLink: "https://referral.appstle.com/SAMPLE-TOKEN", referredCompleted: 3 }; }

  Array.prototype.forEach.call(roots, function (root) {
    var DESIGN = root.getAttribute("data-design-mode") === "true" || (typeof window.Shopify !== "undefined" && window.Shopify && window.Shopify.designMode === true);
    var BASE = (root.getAttribute("data-loyalty-base") || "/apps/loyalty/cp/api/").replace(/\/+$/, "") + "/";
    var SUBJECT = root.getAttribute("data-share-subject") || "";
    var MESSAGE = root.getAttribute("data-share-message") || "";
    var COPY_LABEL = root.getAttribute("data-copy-label") || "Copy my link";
    var COPIED_LABEL = root.getAttribute("data-copied-label") || "Copied!";
    var PROG_LABEL = root.getAttribute("data-progress-label") || "";
    var PROG_EMPTY = root.getAttribute("data-progress-empty") || "";

    function region(name) { return root.querySelector('[data-mp-region="' + name + '"]'); }

    var link = null;

    /* ---- progress ---- */
    function renderProgress(count) {
      var n = region("ref-count"), l = region("prog-label");
      if (count != null && count > 0) {
        if (n) { n.textContent = String(count); n.classList.remove("is-empty"); }
        if (l) l.textContent = PROG_LABEL;
      } else {
        if (n) n.classList.add("is-empty");
        if (l) l.textContent = PROG_EMPTY;
      }
    }

    /* ---- share targets (all carry the REAL link; raw URL never rendered) ---- */
    function body() { return (MESSAGE ? (MESSAGE + " ") : "") + link; }
    function doEmail() { window.location.href = "mailto:?subject=" + encodeURIComponent(SUBJECT) + "&body=" + encodeURIComponent((MESSAGE ? (MESSAGE + "\n\n") : "") + link); }
    function doSms() { window.location.href = "sms:?&body=" + encodeURIComponent(body()); }
    function doNative() {
      if (navigator.share) { navigator.share({ title: SUBJECT || document.title, text: MESSAGE, url: link }).catch(function () {}); }
      else { copyLink(); }
    }
    function copyLink() {
      function flash() {
        var b = root.querySelector("[data-mp-copy]"); if (!b) return;
        b.textContent = COPIED_LABEL; b.classList.add("is-copied");
        setTimeout(function () { b.textContent = COPY_LABEL; b.classList.remove("is-copied"); }, 1800);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(link).then(flash, fallbackCopy);
      } else { fallbackCopy(); }
      function fallbackCopy() {
        try { var ta = document.createElement("textarea"); ta.value = link; ta.setAttribute("readonly", ""); ta.style.position = "absolute"; ta.style.left = "-9999px"; document.body.appendChild(ta); ta.select(); document.execCommand("copy"); document.body.removeChild(ta); flash(); } catch (e) {}
      }
    }

    /* wire the buttons once and enable them when a real link is present */
    var copyBtn = root.querySelector("[data-mp-copy]");
    if (copyBtn) copyBtn.addEventListener("click", function (e) { e.preventDefault(); if (link) copyLink(); });
    Array.prototype.forEach.call(root.querySelectorAll("[data-mp-share]"), function (b) {
      b.addEventListener("click", function (e) {
        e.preventDefault(); if (!link) return;
        var k = b.getAttribute("data-mp-share");
        if (k === "email") doEmail(); else if (k === "sms") doSms(); else doNative();
      });
    });

    function enableActions() {
      if (!link) return;
      Array.prototype.forEach.call(root.querySelectorAll("[data-mp-copy],[data-mp-share]"), function (b) { b.removeAttribute("disabled"); });
    }

    function apply(cust) {
      if (!cust || typeof cust !== "object") return;
      var u = referralUrlOf(cust);
      if (u) { link = u; root.hidden = false; var emp = region("empty"); if (emp) emp.classList.add("lrc-mp__hide"); enableActions(); }
      renderProgress(completedOf(cust));
    }

    /* optional richer detail — completed count from the referrals ledger if present */
    function loadReferrals() {
      fetch(BASE + "customer-referrals", { method: "GET", credentials: "same-origin", headers: { "Accept": "application/json" } })
        .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })
        .then(function (res) {
          if (!res) return;
          var rows = toArray(res);
          if (!rows.length) return;
          var done = rows.filter(function (r) { var st = String(pick(r, ["status", "state"], "")).toUpperCase(); return st.indexOf("COMPLET") > -1 || st.indexOf("SUCCESS") > -1 || pick(r, ["completed", "isCompleted"], false) === true; });
          if (done.length) renderProgress(done.length);
        });
    }

    /* boot */
    if (DESIGN) { apply(sampleCustomer()); return; }
    clFetch(BASE).then(function (cust) { apply(cust); });
    loadReferrals();
  });
})();
